export const TdmInfoGroup = ({ children }: { children: React.ReactNode }) => {
  return <div className='grid grid-cols-3 p-7'>{children}</div>;
};

interface TdmInfoProps {
  title: string;
  children?: React.ReactNode;
  noBorder?: boolean;
  bold?: boolean;
}
export const TdmInfo = (props: TdmInfoProps) => {
  const { title, children, noBorder = false, bold = false } = props;
  return (
    <>
      <div className='col-span-3 md:col-span-1 text-sm text-gray-500'>{title}</div>
      <div className={`col-span-3 md:col-span-2 ${bold ? 'font-bold' : ''}`}>{children}</div>
      {!noBorder && <span className='border-b col-span-3 mt-4 mb-6' />}
    </>
  );
};
